module.exports = __webpack_public_path__ + "img/icon.4c7a66c3.png";